<script setup>
import { useMessageOrigin } from 'dashboard/composables/useMessageOrigin';

const props = defineProps({
  sourceId: { type: String, default: '' },
  senderType: { type: String, default: null },
  messageType: { type: Number, required: true },
});

const { sourceId, senderType, messageType } = props;

const { messageOrigin } = useMessageOrigin({
  sourceId,
  senderType,
  messageType,
});
</script>

<template>
  <!-- Solo mostrar un elemento marcador cuando es mensaje de Chatwoot -->
  <div
    v-if="messageOrigin === 'chatwoot'"
    class="chatwoot-origin-marker"
    data-origin="chatwoot"
  />
  <div v-else />
</template>

<style scoped>
.chatwoot-origin-marker {
  /* Elemento invisible que solo sirve como marcador para CSS :has() */
  position: absolute;
  width: 0;
  height: 0;
  pointer-events: none;
}
</style>
